import React from 'react';
import { useSelector } from 'react-redux';
import { TcsmStates } from '../../root/tcsm-model';
import { DioBackButtons, DomesticBackButtons, HomeBackButtons, NonDomesticBackButtons, NonDomesticDioBackButtons, RegionBackButtons } from './back-button/app-back-buttons';
import { CurrentContext } from './models';


export function ClergyCompReportNav() {
	const context = useSelector<TcsmStates, CurrentContext>(state => state.clergyCompReportState.currentContext);

	switch (context) {
		case CurrentContext.LANDING:
			return <HomeBackButtons />;
		case CurrentContext.DOMESTIC:
			return <DomesticBackButtons />;
		case CurrentContext.INTERNATIONAL:
			return <NonDomesticBackButtons />;
		case CurrentContext.REGION:
			return <RegionBackButtons />;
		case CurrentContext.DIOCESE:
			return <DioBackButtons />;
		case CurrentContext.INTERNATIONDIO:
			return <NonDomesticDioBackButtons />;
		default:
			return <HomeBackButtons />;
	}
}